import React from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

import { SearchContext } from './search-context';

/**
Context provider for search facet filter selection SEO data
@examples
```jsx
<SeachSeoData>
    {({ dynamicSEO }) => {
        return <SeoMeta seo={dynamicSEO} />;
    }}
</SeachSeoData>
```
@component SearchFilter
@import SearchFilter
@example ../docs/SearchFilter.md
@returns {ReactElement} The rendered component
*/
export default ({ children }) => {
    const { pathname } = useLocation();
    return (
        <SearchContext.Consumer>
            {({ dynamicSEO, seralizedQuery }) => {
                return children({ dynamicSEO, seralizedQuery: seralizedQuery || pathname });
            }}
        </SearchContext.Consumer>
    );
};
